import { render, staticRenderFns } from "./bcc-email-setting.vue?vue&type=template&id=98ecdd06"
import script from "./bcc-email-setting.vue?vue&type=script&lang=js"
export * from "./bcc-email-setting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports